function fetchScript(url, params) {
  var searchParams = new URLSearchParams();
  Object.keys(params || {}).forEach(function(key) {
    var value = params[key];
    if (Array.isArray(value)) {
      value.forEach(function(item) {
        searchParams.append(key + '[]', item);
      });
    } else if (value != null) {
      searchParams.append(key, value);
    }
  });

  fetch(url + '?' + searchParams.toString(), {
    headers: {
      'Accept': 'text/javascript, application/javascript, */*; q=0.01',
      'X-Requested-With': 'XMLHttpRequest'
    },
    credentials: 'same-origin'
  }).then(function(res) { return res.text(); }).then(function(js) {
    var script = document.createElement('script');
    script.textContent = js;
    document.head.appendChild(script);
    document.head.removeChild(script);
  });
}

var widgetPriceCompactInitialize = function() {
  var cardsArray = [];
  document.querySelectorAll(".widget-price-compact-placeholder").forEach(function(el) {
    cardsArray.push(el.dataset.card);
  });
  if (cardsArray.length > 0) {
    var chunk = 25;
    for (var i = 0; i < cardsArray.length; i += chunk) {
      var tempArray = cardsArray.slice(i, i + chunk);
      fetchScript("/widgets/price_compact/js", { cards: tempArray });
    }
  }
};

document.addEventListener('DOMContentLoaded', function() {
  widgetPriceCompactInitialize();
});
